import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-socialize]')) return;

  addEventListeners();
}

function addEventListeners() {
  const links = $$('[data-au-socialize-link]');
  const linkDownload = $$('[data-au-socialize] [data-au-download-file]');

  links.forEach((link) => {
    link.addEventListener('click', (e) => handleClick(e, link));
  });

  linkDownload.forEach((link) => {
    link.addEventListener('click', (e) => handleClickDownloadOnArticle(e));
  });
}

function handleClick(e, link) {
  e.preventDefault();

  const data = {
    target: link.dataset.auSocializeLink,
    url: link.dataset.url || window.location.href,
    title: link.dataset.title || document.title,
    desc: link.dataset.desc || getMetaContent('og:description') || getMetaContent('description'),
    image: link.dataset.image || getMetaContent('og:image'),
  };

  let p = {},
    u = '';

  switch (data.target) {
    case 'x':
      p = { url: data.url, text: data.title, count: 'none/' };
      u = `http://x.com/share?${new URLSearchParams(p).toString()}`;
      openPopup(u, 'tweet', 300, 550);
      break;

    case 'facebook':
      p = { u: data.url };
      u = `http://www.facebook.com/sharer.php?${new URLSearchParams(p).toString()}`;
      openPopup(u, 'facebook', 300, 550);
      break;

    case 'linkedin':
      p = { mini: 'true', url: data.url, title: data.title, summary: data.desc, source: '' };
      u = `https://www.linkedin.com/shareArticle?${new URLSearchParams(p).toString()}`;
      openPopup(u, 'LinkedIn', 300, 550);
      break;

    case 'email':
      u = `mailto:?subject=${encodeURIComponent(data.title)}&body=${encodeURIComponent(data.desc)}%0D%0A%0D%0A${encodeURIComponent(data.url)}`;
      // eslint-disable-next-line no-case-declarations
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = u;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      break;

    default:
      break;
  }

  const clickText = link.querySelector(':not([data-au-icon])').innerText;
  const item_id = `compartir_${removeAccentMarkAndUppercase(clickText)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickIcono',
    item_id,
  });
}

function handleClickDownloadOnArticle(e) {
  const el = e.currentTarget;
  const clickText = el.querySelector(':not([data-au-icon])').innerText;
  const item_id = `compartir_${removeAccentMarkAndUppercase(clickText)} ok`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickDescarga',
    item_id,
  });
}

function getMetaContent(property) {
  const meta = $(`meta[property="${property}"]`) || $(`meta[name="${property}"]`);
  return meta ? meta.content : '';
}

function openPopup(url, name, height, width) {
  window.open(url, name, `height=${height},width=${width},scrollbars=1,resizable=1`);
}

export default { init };
